export enum LocationType {
  TOWN = 'town',
  AREA_CODE = 'area_code',
  COUNTY = 'county'
}
